// extracted by css-extract-rspack-plugin
export default {"root":"root-w3IY5t","input":"input-szPUWP"};